module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=UA - Ukraine.3d4605a0.svg";